<template>
  <QuestionStepItem :item="questionItem" :show-info-text="props.showInfoText" class="mb-4"></QuestionStepItem>
</template>

<script setup lang="ts">
import QuestionStepItem from './StepItems/QuestionStepItem.vue'
import type { QuestionItem, TemplateVariable } from '@/questionnaire/types'
// import { useQuestionnaireStore } from '../stores/questionnaire'

const props = defineProps<{ templateVariable: TemplateVariable; showInfoText: boolean }>()
const questionItem: QuestionItem = {
  item_type: 'question',
  question_code: props.templateVariable.code,
}
</script>
